import React, { useCallback, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import {
  ReactComponent as ChevronIcon,
} from '../../../assets/chevron-white.svg';

import { EmailOptionCard } from './EmailOptionCard';
import {
  EMAIL_OPTIONS,
  maskEmail,
} from './utils';

import styles from './SelectEmailScreen.module.css';

const SelectEmailScreen = ({
  newEmail = '',
  onContinue = () => { },
  registeredEmail = '',
}) => {
  const { t } = useTranslation('petDemos');
  const [selectedOption, setSelectedOption] = useState(EMAIL_OPTIONS.NEW_EMAIL);

  const handleSelectNew = useCallback(() => {
    setSelectedOption(EMAIL_OPTIONS.NEW_EMAIL);
  }, []);

  const handleSelectRegistered = useCallback(() => {
    setSelectedOption(EMAIL_OPTIONS.REGISTERED_EMAIL);
  }, []);

  const handleContinue = useCallback(() => {
    onContinue(selectedOption);
  }, [onContinue, selectedOption]);

  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <h1 className={styles.title}>
          {t('certificateLinking.selectEmail.title')}
        </h1>

        <p className={styles.description}>
          <Trans
            components={{ bold: <span className={styles.descriptionBold} /> }}
            i18nKey="certificateLinking.selectEmail.description"
            t={t}
          />
        </p>
      </div>

      <div className={styles.cardsContainer}>
        <EmailOptionCard
          email={newEmail}
          isRecommended
          isSelected={selectedOption === EMAIL_OPTIONS.NEW_EMAIL}
          label={t('certificateLinking.selectEmail.setNewEmail')}
          onSelect={handleSelectNew}
          recommendedLabel={t('certificateLinking.selectEmail.recommended')}
        />

        <EmailOptionCard
          email={maskEmail(registeredEmail)}
          isSelected={selectedOption === EMAIL_OPTIONS.REGISTERED_EMAIL}
          label={t('certificateLinking.selectEmail.startOver')}
          onSelect={handleSelectRegistered}
        />
      </div>

      <button
        className={styles.continueButton}
        onClick={handleContinue}
        type="button"
      >
        {t('certificateLinking.selectEmail.continue')}

        <ChevronIcon className={styles.arrow} />
      </button>
    </div>
  );
};

export { SelectEmailScreen };
